<template>
  <div class="app-container">
    <el-button type="primary" @click="addManagerMenu()"> 添加菜单 </el-button>
    <div style="margin-top: 20px">
      <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ data }">
          <span>{{ data.name }}</span>
          <div class="block">
            <el-button type="success" size="small" @click="() => append(data)"> 添加菜单 </el-button>
            <el-button type="primary" size="small" @click="() => edit(data)"> 编辑菜单 </el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" @click="() => remove(data)"></el-button>
          </div>
        </span>
      </el-tree>
    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType === 'edit' ? '编辑菜单' : '添加菜单'" :close-on-click-modal="false">
      <el-form :model="menu" ref="menu" label-width="100px" class="demo-ruleForm">
        <el-form-item label="上级菜单" prop="pid">
          <el-select v-model="menu.pid" placeholder="请选择">
            <el-option v-for="item in routes" :label="item.name" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="menu.name" @input="nameinput"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input v-model="menu.path" @input="pathInut"></el-input>
        </el-form-item>
        <el-form-item label="面包屑设置" prop="redirect">
          <el-input v-model="menu.redirect"></el-input>
        </el-form-item>
        <el-form-item label="组件设置" prop="component">
          <el-input v-model="menu.component"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="name">
          <el-input v-model.number="menu.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏" prop="hidden">
          <el-switch v-model="menu.hidden"></el-switch>
        </el-form-item>
        <el-form-item label="跟路由显示" prop="alwaysShow">
          <el-switch v-model="menu.alwaysShow"></el-switch>
        </el-form-item>
        <el-form-item label="不缓存" prop="noCache">
          <el-switch v-model="menu.meta.noCache"></el-switch>
        </el-form-item>
        <el-form-item label="菜单标题" prop="meta.title">
          <el-input v-model="menu.meta.title"></el-input>
        </el-form-item>
        <el-form-item label="icon" prop="meta.icon">
          <el-input v-model="menu.meta.icon"></el-input>
        </el-form-item>
        <!-- <el-form-item label="权限分组" prop="roles">
          <el-checkbox-group v-model="menu.meta.roles" >
            <el-checkbox v-for="item in roles" :label="item.roles" :key="item.roles">{{ item.desc }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="confirm(menu)">保存</el-button>
          <el-button @click="cancel()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import {
//   getManagerAllMenu,
//   addManagerMenu,
//   editManagerMenu,
//   deleteManagerMenu,
//   getmanagerRoutes,
// } from "@/api/menu";
// import i18n from "@/lang";
export default {
  data() {
    return {
      data: [],
      routes: [],
      dialogType: "add",
      menu: {
        id: "",
        name: "",
        pid: "",
        redirect: "",
        component: "",
        hidden: false,
        alwaysShow: false,
        meta: {
          title: "",
          icon: "list1",
          roles: [],
          noCache: true,
        },
      },
      hidden: "",
      alwaysShow: "",
      dialogVisible: false,
      roles: [],

      data: [],
      routes: [],
    };
  },
  created() {
    this.getMenu();
    this.managerRoutesFun();
    this.getmanagerRoutes()

  },

  methods: {
    //取消
    cancel() {
      this.dialogVisible = false;
    },
    async getMenu() {
      const res = await this.$http.get(this.$urls.getManagerAllMenu)
      this.data = JSON.parse(JSON.stringify(res.menu));
      console.log(this.data, "?!@");
    },

    async managerRoutesFun() {
      const res = await this.$http.get(this.$urls.ManagerRoutes)
      this.routes = JSON.parse(JSON.stringify(res.data));
      console.log(this.routes, "路由");
    },

    append(data) {
      console.log(data);
      var self = this;
      self.menu = {
        name: "",
        pid: "",
        redirect: "",
        component: data.path.split("/")[1] + "/",
        hidden: false,
        alwaysShow: false,
        sort: data.hasOwnProperty("children") ? data.children.length : 0,
        meta: {
          title: "",
          icon: "list1",
          roles: [],
          noCache: true,
        },
      };
      this.menu.pid = data.id;
      this.dialogType = "new";
      this.dialogVisible = true;
    },

    addManagerMenu() {
      var self = this;
      self.menu = {
        name: "",
        pid: "",
        path: "/",
        redirect: "",
        component: "Layout",
        hidden: false,
        alwaysShow: true,
        sort: this.data.length,
        meta: {
          title: "",
          icon: "list1",
          roles: [],
          noCache: true,
        },
      };
      this.dialogType = "new";
      this.dialogVisible = true;
    },

    edit(data) {
      this.menu = Object.assign({}, data);
      this.menu.meta.noCache = this.menu.meta.noCache == "true" ? true : false;
      this.dialogType = "edit";
      this.dialogVisible = true;
    },
    async confirm(e) {
      const isEdit = this.dialogType === "edit";
      if (isEdit) {
        const res = await this.$http.post(this.$urls.editManagerMenu, this.menu)
        if (res.errcode == 0) {
          this.$message({ type: "success", message: "编辑成功" });
          this.dialogVisible = false;
          this.getMenu();
          this.getmanagerRoutes();
        } else {
          this.$message({ type: "error", message: "编辑失败" });
        }
      } else {
        const res = await this.$http.post(this.$urls.addManagerMenu, {...this.menu})
        if (res.errcode == 0) {
          this.$message({ type: "success", message: "添加成功" });
          this.dialogVisible = false;
          this.getMenu();
          this.getmanagerRoutes();
        } else {
          this.$message({ type: "error", message: "添加失败" });
        }
      }
    },

    async getmanagerRoutes() {
      const res = await ManagerRoles();
      this.routes = JSON.parse(JSON.stringify(res.data));
    },

    remove(data) {
      this.$confirm("您确定删除么?", "警告！", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$http.get(this.$urls.deleteManagerMenu, {id: data.id})
          if (res.errcode == 0) {
            this.$message({ type: "success", message: "删除成功" });
            this.getMenu();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nameinput() {
      this.menu.meta.title = this.menu.name;
    },
    pathInut(e) {},
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
}

.block {
  display: block;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 8px;
}

.el-tree /deep/.el-tree-node__content {
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/power_ment/manager/index.vue